"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstName = exports.splitFullName = exports.fullName = void 0;
const fullName = (...names) => names.filter((name) => name).join(" ");
exports.fullName = fullName;
function splitFullName(name = "") {
    return name.split(" ", 2).filter((part) => !!part);
}
exports.splitFullName = splitFullName;
function firstName(name = "", ifEmpty = "") {
    const nameParts = splitFullName(name);
    if (nameParts.length) {
        return nameParts[0];
    }
    return ifEmpty;
}
exports.firstName = firstName;
//# sourceMappingURL=index.js.map